import { Component } from 'react';
import { withRouter } from 'react-router-dom';

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      const { elementRef } = this.props;
      if (!elementRef || !elementRef.current || !elementRef.current.scrollIntoView) {
        return;
      }

      elementRef.current.scrollIntoView();
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);
